import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { PriceService } from "src/app/dashboard/price/price.service";
import { ShopService } from "src/app/dashboard/shop/shop.service";
import { UserService } from "src/service/user.service";

@Component({
  selector: "app-language-selector",
  templateUrl: "./language-selector.component.html",
  styleUrls: ["./language-selector.component.scss"],
})
export class LanguageSelectorComponent implements OnInit {
  constructor(
    private translateService: TranslateService,
    private priceService: PriceService,
    private shopService: ShopService,
    private userService: UserService
  ) {
    this.currentLanguage = this.translateService.currentLang;
    this.userService.updateLanguage(this.currentLanguage).subscribe();
    this.currentLanguageItem = this.languagesList.find(
      (item) => item.code == this.currentLanguage
    );
    this.filteredLanguageList = this.languagesList.slice().filter(
      (item) => item.code != this.currentLanguage
    );
  }

  currentLanguageItem;
  currentLanguage;
  languagesList = [
    {
      code: "en",
      title: "ENGLISH",
      flag: "ic_flag_en.svg",
    },
    {
      code: "de",
      title: "DEUTSCH",
      flag: "ic_flag_de.svg",
    },
    {
      code: "nl",
      title: "NEDERLANDS",
      flag: "ic_flag_nl.svg",
    },
    {
      code: "fr",
      title: "FRENCH",
      flag: "ic_flag_fr.svg",
    },
    {
      code: "tr",
      title: "TURKISH",
      flag: "ic_flag_tr.svg",
    },
  ];

  filteredLanguageList;

  ngOnInit(): void {}

  setLanguage(languageItem) {
    this.translateService.use(languageItem.code);
    this.currentLanguageItem = languageItem;
    this.currentLanguage = this.translateService.currentLang;
    this.filteredLanguageList = this.languagesList.slice().filter(
      (item) => item.code != languageItem.code
    );
    this.priceService.syncProductLanguage(languageItem.code.toUpperCase());
    this.shopService.refreshCurrentList();
    this.userService.updateLanguage(languageItem.code).subscribe();
  }
}
